import PasienTag from "@/services/new/PasienTag";
// import ListPasienRalan from "@/store/modules/new/ListPasienRalan";
import { storePasien } from "@/store/modules/pasien";

function toggleHeartFailureIndicator(
  addedCallback: Function,
  removedCallback: Function
) {
  if (!storePasien.isTagRegHF) {
    const q = confirm("Tandai pasien ini untuk Register Klinik Gagal Jantung?");

    if (q) {
      PasienTag.setRegHF(storePasien.identitasPasien.rm)
        .then(resp => {
          if (resp.status == 1) {
            addedCallback();
          }
        })
        .catch(err => {
          if (err.response) {
            alert(`ERR ${err.response.status}: ${err.response.data.message}`);
          }
        });
    }
  } else {
    const q = confirm(
      "Menghapus tanda pasien ini dari Register Klinik Gagal Jantung?"
    );

    if (q) {
      PasienTag.removeRegHF(storePasien.identitasPasien.rm)
        .then(resp => {
          if (resp.status == 1) {
            removedCallback();
          }
        })
        .catch(err => {
          if (err.response) {
            alert(`ERR ${err.response.status}: ${err.response.data.message}`);
          }
        });
    }
  }
}

export { toggleHeartFailureIndicator };
